import { type MCPServerInfo } from '../../types';

const UsPtoServer: MCPServerInfo = {
  serverId: 'US_PTO',
  name: 'US PTO',
  slug: 'us-pto',
  description: 'US Patents and Technology Office MCP Server',
  source: {
    sourceType: 'REPOSITORY',
    type: 'COMMUNITY',
    repositoryUrl: 'mcp/patents:latest',
    commitSha: 'latest',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['usptoApiKey'],
    properties: {
      usptoApiKey: {
        type: 'string',
        description: 'uspto API Key',
        sensitive: true
      }
    }
  },
  deprecated: true
};

export default UsPtoServer;
